// Shared, DOM-free helpers/types for the search & filter analytics
// (see docs/superpowers/specs/2026-08-29-search-filter-analytics-design.md).
/**
 * Drops keys whose value is undefined or '' so Umami/GA4 never receive a
 * literal "undefined" string or a noise-only empty param. Booleans (incl.
 * false) and 0 are kept.
 */
export function compact(data) {
    var out = {};
    Object.keys(data).forEach(function (key) {
        var value = data[key];
        if (value !== undefined && value !== '') {
            out[key] = value;
        }
    });
    return out;
}
